import { REQUEST_BUSINESS_TRIP_EDIT_PATH } from "@/modules/requests/pages/business-trip-request";
import { generatePath, Navigate } from "react-router-dom";

export function OpenBusinessTripRequest() {
  return (
    <Navigate
      to={generatePath(REQUEST_BUSINESS_TRIP_EDIT_PATH, {
        id: new URL(window.location.href).searchParams.get("id"),
      })}
    />
  );
}
